import InternalServerError from '@/views/error/InternalServerError.vue'
import Page503 from '@/views/error/Page503.vue'

export default [
  {
    path: '/:pathMatch(.*)*',
    name: 'InternalServerError',
    component: InternalServerError,
    meta: {
      title: 'Błąd 500',
      metaTags: [{ name: 'robots', content: 'noindex' }]
    }
  },
  {
    path: '/blad/503',
    name: 'Page 503',
    component: Page503,
    meta: {
      title: 'Błąd 503',
      metaTags: [{ name: 'robots', content: 'noindex' }]
    }
  }
]
